import { IsIn, IsArray, ArrayMinSize, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { BaseTaskDto } from './base-task.dto';
import { NodeActionDto } from './node-action.dto';

export class UserTaskDto extends BaseTaskDto {
  @IsIn(['UserTask'])
  type: 'UserTask';

  @IsArray()
  @ArrayMinSize(1, { message: 'Обязательное поле' })
  @ValidateNested({ each: true })
  @Type(() => NodeActionDto)
  actions: NodeActionDto[];
}
